import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import { TRefundsStore, TRefundsResponsePayload, TRefundBreakdownResponsePayload } from './types';

export const getRefundsState = (state: TStoreState): TRefundsStore => state.refunds;

export const getRefundsStore = getRefundsState;

// ==========================================:

export const getRefunds = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): TRefundsResponsePayload => refunds.refunds,
);

// ==========================================:

export const getRefundsLoader = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): boolean => refunds.refundsLoader,
);

// ==========================================:

export const getRefundsForFilterId = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): TRefundsResponsePayload => refunds.refundsForFilterId,
);

// ==========================================:

export const getRefundsForFilterIdLoader = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): boolean => refunds.refundsForFilterIdLoader,
);

// ==========================================:

export const getRefund = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): TRefundsResponsePayload => refunds.refund,
);

// ==========================================:

export const getRefundLoader = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): boolean => refunds.refundLoader,
);

// ==========================================:

export const getRefundBreakdown = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): TRefundBreakdownResponsePayload => refunds.refundBreakdown,
);

// ==========================================:

export const getRefundBreakdownLoader = createSelector(
	[getRefundsStore],
	(refunds: TRefundsStore): boolean => refunds.refundBreakdownLoader,
);
